














































import Vue from 'vue';
import Component from 'vue-class-component';
import { Resolve } from 'vue-di';
import { Prop } from 'vue-property-decorator';
import BaseView from '../BaseView';
import CommonTools from '~/components/tools/commonTools';
import SearchModule from '~/store/search';
import styles from '~/assets/style/variables.scss';

@Component<PatientDetailCard>({})
export default class PatientDetailCard extends BaseView {
    @Resolve
    searchModule!: SearchModule;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    patient: any;

    beforeMount() {
        this.patient = this.searchModule.getCurrentPatient() || {};
    }
}
